export default __webpack_public_path__ + "static/media/skovstykket-floorplans-apartment-4-02.a5fdd586.jpg";